<template>
  <div class="mt-5">
    <form @submit.prevent="roleCreate">

      <h3>Role Create</h3>

      <div class="form-group">
        <label>Name</label>
        <input type="text" class="form-control form-control-lg" v-model="name"/>
      </div>

      <button type="submit" class="btn btn-dark btn-lg btn-block mt-2">Create</button>

    </form>
  </div>
</template>

<script>
import axios from "axios";
import tokenRefresh from "@/utils/tokenRefresh";
import statusCheck from "@/utils/statusCheck";

export default {
  name: "RoleCreate.vue",
  data() {
    return {
      name: '',
    }
  },
  methods: {
    roleCreate: function () {
      const {name} = this;
      console.log(name);
      axios.post(process.env.VUE_APP_CRAWLING_URL + "/api/role/create", {name})
          .then((response) => {
                if (response.status === 201) {
                  tokenRefresh();
                  this.$router.push({name: "roles"});
                }
              }
          )
          .catch((error) => {
                statusCheck(error.response.status);
              }
          )
    }
  }
}
</script>

<style scoped>

</style>